import { createAction, props } from '@ngrx/store';
import { SheetTemplate } from 'src/app/types/sheet.types';

export enum SheetTemplateManagementActionTypes {
	LoadTemplatesRequested = '[Manage Sheet Templates Modal] Load Templates Requested',
	LoadTemplatesCompleted = '[Manage Sheet Templates Modal] Load Templates Completed',
	RenameTemplateRequested = '[Manage Sheet Templates Modal] Rename Template Requested',
	RenameTemplateCompleted = '[Manage Sheet Templates Modal] Rename Template Completed',
	ChangeTemplateActiveStateRequested = '[Manage Sheet Templates Modal] Change Template Active State Requested',
	ChangeTemplateActiveStateCompleted = '[Manage Sheet Templates Modal] Change Template Active State Completed',
	TemplatesUnloaded = '[Manage Sheet Templates Modal] Templates Unloaded',
	DeleteTemplateRequested = '[Manage Sheet Templates Modal] Delete Template Requested',
	DeleteTemplateCompleted = '[Manage Sheet Templates Modal] Delete Template Completed'
}

export const loadTemplatesRequested = createAction(
	SheetTemplateManagementActionTypes.LoadTemplatesRequested
)

export const loadTemplatesCompleted = createAction(
	SheetTemplateManagementActionTypes.LoadTemplatesCompleted,
	props<{ templates: SheetTemplate[] }>()
)

export const renameTemplateRequested = createAction(
	SheetTemplateManagementActionTypes.RenameTemplateRequested,
	props<{ templateId: string, newName: string }>()
)

export const renameTemplateCompleted = createAction(
	SheetTemplateManagementActionTypes.RenameTemplateCompleted,
	props<{ template: SheetTemplate }>()
)

export const changeTemplateActiveStateRequested = createAction(
	SheetTemplateManagementActionTypes.ChangeTemplateActiveStateRequested,
	props<{ templateId: string, isActive: boolean }>()
)

export const changeTemplateActiveStateCompleted = createAction(
	SheetTemplateManagementActionTypes.ChangeTemplateActiveStateCompleted,
	props<{ template: SheetTemplate }>()
)

export const deleteTemplateRequested = createAction(
	SheetTemplateManagementActionTypes.DeleteTemplateRequested,
	props<{ templateId: string }>()
)

export const deleteTemplateCompleted = createAction(
	SheetTemplateManagementActionTypes.DeleteTemplateCompleted,
	props<{ templateId: string }>()
)

export const templatesUnloaded = createAction(
	SheetTemplateManagementActionTypes.TemplatesUnloaded
)